import React, {useEffect, useState} from "react";
import './RegionsList.scss';

import Header from "../../components/Header";
import Button from "react-bootstrap/Button";
import Footer from "../../components/Footer";
import Alert from "react-bootstrap/Alert";

let img_top = require("../../assets/Blog.jpg");

function RegionsList() {
    const [list, setList] = useState([]);
    const [country, setCountry] = useState("italia");
    useEffect(() => {
        document.title = "Geoticket - Regioni";
    }, []);

    useEffect(() => {
        fetch(global.route.regionList, {
            method: "post",
            credentials: 'include',
        })
            .then(response => {
                if (response.status === 200) {
                    response.json().then(response => {
                        setList(response.region_list);
                    });
                }
            });
    }, []);


    let getList = () => {
        if (list.length === 0) {
            return <Alert key={"warning"} variant={"warning"}>Nessun dato disponibile</Alert>;
        }
        let result = [];
        for (let item of list[country]) {
            result.push(<div className={"col-md-4"}>
                <div
                    onClick={() => {
                        window.location.href = "/regions/" + item.region
                    }}
                    key={"region" + item.id}
                    className={"card-container card-background"}
                    style={{backgroundImage: `url(${encodeURI(global.baseUrl + item.image)})`}}
                >
                    <span><b>{item.region}</b></span>
                </div>
                <div className={"d-flex justify-content-center align-items-center"}>
                <Button className={"btn-orange"}
                        style={{marginTop: -32, zIndex: 100, position: "sticky"}}
                        onClick={() => {
                            window.location.href = "/regions/" + item.region
                        }}>Seleziona</Button>
                </div>
            </div>);
        }
        return <div className={"row"}>{result}</div>;
    }

    let getCountry = () => {
        let list_country = [];
        for (let item in list) {
            list_country.push(<option key={item} value={item}>
                {item}
            </option>);
        }

        return <div className={"d-flex justify-content-center align-items-center flex-column"}>
            <h5><b>Cambia il paese di visualizzazione</b></h5>
            <select class="form-select" value={country} onChange={(e) => setCountry(e.target.value)}>
                <option disabled>Seleziona il paese</option>
                {list_country}
            </select></div>;
    }
    return (
        <div style={{backgroundColor: "#fafafa"}} className={"region-list"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Regioni</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{backgroundColor: "#51b270"}}>
                <div className={"container pt-4 pb-4"}>

                    {getCountry()}
                </div>

            </div>
            <div className={"container mt-4 mb-4"}>
                {getList()}
            </div>
            <Footer/>
        </div>
    );
}

export default RegionsList;